import { useTranslation } from "react-i18next";
import { RootState } from "../../store/root-reducer";
import { connect, useSelector } from "react-redux";
import { CancellationServiceFileTypeSteps } from "./types";
import FieldBlock from "../../components/CreateClaim/FieldBlock";

function ReviewCancellationService() {
  const { t } = useTranslation();
  const { customerDetails, purchaseDetails, documents, cancellation_reason } =
    useSelector((state: RootState) => state.cancellationService);

  return (
    <div className="space-y-6">
      <div>
        <div className="bg-[#EBEEEF]  text-black font-semibold min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
          {t(CancellationServiceFileTypeSteps.CUSTOMER_DETAILS)}
        </div>
        <div className="bg-white grid gap-1.5 divide-y-[1px] divide-[#F0F0F0] px-2 py-2">
          <FieldBlock label="Name" value={customerDetails.name} />
          <FieldBlock label="Email" value={customerDetails.email} />
          <FieldBlock label="Phone" value={customerDetails.phone} />
          <FieldBlock label="Address" value={customerDetails.address} />
          <FieldBlock label="City" value={customerDetails.city} />
          <FieldBlock label="State" value={customerDetails.state} />
          <FieldBlock label="Zip code" value={customerDetails.zip_code} />
        </div>
      </div>
      <div>
        <div className="bg-[#EBEEEF]  text-black font-semibold min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
          {t(CancellationServiceFileTypeSteps.PURCHASE_DETAILS)}
        </div>
        <div className="bg-white grid gap-1.5 divide-y-[1px] divide-[#F0F0F0] px-2 py-2">
          <FieldBlock label="Invoice" value={documents.invoice?.[0]} image />
          <FieldBlock label="Invoice Number" value={purchaseDetails.invoice} />
          <FieldBlock
            label="Date of Purchase"
            value={purchaseDetails.date_of_purchase}
            date
          />
          <FieldBlock label="Store Name" value={purchaseDetails.store_name} />
          <FieldBlock label="Store Phone" value={purchaseDetails.store_phone} />
          <FieldBlock
            label="Store Address"
            value={purchaseDetails.store_address}
          />
          <FieldBlock label="Store City" value={purchaseDetails.store_city} />
          <FieldBlock label="Store State" value={purchaseDetails.store_state} />
          <FieldBlock
            label="Store Zip code"
            value={purchaseDetails.store_zip}
          />
          <FieldBlock
            label="Were any items exchanged"
            value={purchaseDetails.were_any_items_exchanged}
          />
        </div>
      </div>
      <div>
        <div className="bg-[#EBEEEF]  text-black font-semibold min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
          {t(CancellationServiceFileTypeSteps.CANCELLATION_REASON)}
        </div>
        <div className="bg-white grid gap-1.5 divide-y-[1px] divide-[#F0F0F0] px-2 py-2">
          <FieldBlock label="Cancellation Reason" value={cancellation_reason} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  data: state?.cancellationService || {},
});

export default connect(mapStateToProps)(ReviewCancellationService);
